import { Fragment, memo, useEffect, useMemo, useState } from 'react';
import { Dashboard, info_cicrle, link_slash_solid2, logo_card } from '../../../components/ExportImgFigma';
import '../styles.scss';

// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { ConfigProvider, DatePicker, Dropdown, Input, MenuProps, Pagination, Tooltip } from 'antd';

import { EditOutlined, EyeOutlined, GiftOutlined, PlusOutlined, SearchOutlined, SettingOutlined, ToolOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import { PaginationProps } from 'antd/lib';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ICustomerDetail_V4 } from '../../../api/customer/customerApi';
import { FieldsUpdate, getListFieldsByCustomer, ListField, updateFieldUser } from '../../../api/Customer_V2/customerApi_V2';
import { deleteRelativeCustomerChild, getInfoRelativeCustomer, getlistRelativeCustomer, IRelationship_V2, IRelativeCustomer } from '../../../api/relatives/relativesApi';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import { NodataTable } from '../../../components/NoDataTable';
import useDebounce from '../../../hook/useDebounce';
import useThrottle from '../../../hook/useThrottle';
import useToast from '../../../hook/useToast';
import { CustomerType, dataTypeCustomer, FIELDTYPE, NO_DATA, NO_VIEW } from '../../../services/data';
import { formatNumber } from '../../../services/mixin';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { CustomLoadingOverlayTable, dataPagination, generateColumnsFromCodesAgGridReact, getUserPermissions } from '../../../until';
import AddBusiness from '../../Customers/Modal/AddBusiness';
import AddRelativeModal from '../../Customers/Modal/AddRelative';
import UpdateRelative from '../../Customers/Modal/AddRelativeUpdate';
import UpdateBusiness from '../../Customers/Modal/UpdateBusiness';
import { ColumnKey } from '../../Customers/Tabs/CarListCardClone';
import { dataDefaulFilterList, FlattenedField, IDataDefaulFilterList } from '../../CustomersV2/indexV2';
import TabsFeildsCustomer from '../Modal/TabsFeildsCustomer';
dayjs.locale('vi');
const { RangePicker } = DatePicker;

const requiredFieldCodes: string[] = [];
//  onClick={() => navigator(`/customer/list/${idCustomer}`, { state: { groupPermissionId } })}


function getFieldValueObjectTooltip(value: any) {
    if (value === null || value === undefined) return NO_DATA;
    if (typeof value === "object" && !Array.isArray(value)) {
        return value.title ?? NO_DATA;
    }
    if (Array.isArray(value)) {
        let valueTmp: string[] = []
        value.map((item) => {
            if (typeof item === "object") {
                valueTmp.push(item.name)
            } else {
                valueTmp.push(item)
            }
        })
        return valueTmp.length > 0
            ?
            valueTmp.map((item, i) => (
                <div key={i} className="custom-page-css flex flex-col">
                    {item}
                </div>
            ))
            :
            NO_DATA;
    }
    return value;
}



interface Prop {
    infoCustomer?: ICustomerDetail_V4;
}

const Overview: React.FC<Prop> = ({
    infoCustomer
}) => {

    const permissionSlice = useSelector(selectorPermission)
    const { add, edit, delete: isDelete, access, upload, download, share, } = getUserPermissions(permissionSlice, location.pathname)

    const pushToast = useToast();

    const { id, unitTemp, unit } = useSelector(selectorInfoUser) // đợn vị dc chọn
    const navigator = useNavigate()
    const cusNameCellRenderer = (params: any) => {
        const { data } = params;

        return (
            <span
                className="text-1890FF cursor-pointer hover:underline"
                onClick={() => {
                    navigator(`/customer/list/${data.id}`, {
                        state: { groupPermissionId: data.group_permission_id }
                    });
                }}
            >
                {params.value}
            </span>
        );
    };

    // const generateColumnsFromCodesAgGridReact = (
    //     codes: ColumnKey[],
    //     fields: ICustomerFields[],
    //     actionColumn?: ColDef<any, any>,
    //     onToggleStatus?: (id: number, next: boolean, rowData: any) => void, // thêm callback
    // ): ColDef[] => {
    //     const baseColumns = codes
    //         ?.map(code => {
    //             const field = fields.find(f => f.fieldCode === code)
    //             if (!field) return null

    //             let cellRenderer = (params: any) => renderValueAsJSX(params.value,field.fieldCode);

    //             // Hard code field code
    //             if (code === 'cus_name') {
    //                 cellRenderer = cusNameCellRenderer;
    //             }
    //             return {
    //                 headerName: field.fieldLabel,
    //                 headerComponent: FilterHeader,
    //                 field: field.fieldCode,
    //                 colId: field.fieldCode,
    //                 sortable: true,
    //                 width: getWidthFromHeader(field.fieldLabel),
    //                 cellRenderer: cellRenderer
    //             } as ColDef;
    //         })
    //         .filter(Boolean) as ColDef[];

    //     return actionColumn ? [actionColumn, ...baseColumns] : baseColumns;
    // };

    useEffect(() => {
        gListFieldsActive()

        const handleResize = () => {
            const baseFactor = (48 * 100) / 1440 / 100
            const factor = window.innerWidth > 1440 ? baseFactor * 0.9 : baseFactor
            const newHeight = Math.round(window.innerWidth * factor)
            setRowHeight(newHeight)
        }
        handleResize()

        window.addEventListener('resize', handleResize)

        return (() => {
            setDataFilterList(dataDefaulFilterList)

            setPagination({ current: 1, pageSize: 20, total: 0 })
            window.removeEventListener('resize', handleResize)
        })
    }, [])

    const [loadingTable, setLoadingTable] = useState(false)

    const [isSettingShow, setSettingShow] = useState(false)
    const [isAddRelativeModal, setIsAddRelativeModal] = useState(false)
    const [isModalRelativesUpdate, setIsModalRelativesUpdate] = useState(false)
    const [isModalRelativesDelete, setIsModalRelativesDelete] = useState(false)
    const [isModalBusinessAdd, setIsModalBusinessAdd] = useState(false)
    const [isModalBusinessUpdate, setIsModalBusinessUpdate] = useState(false)
    const [isModalBusinessDelete, setIsModalBusinessDelete] = useState(false)

    const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])

    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });


    const [rowHeight, setRowHeight] = useState(40)

    const [dataFieldActive, setDataFieldActive] = useState<FlattenedField[]>([])
    const [dataFieldNoActive, setDataFieldNoActive] = useState<ListField[]>([])

    const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)

    const [idChoose, setIDChoose] = useState<number>()

    const [infoRelative, setInfoRelative] = useState<IRelationship_V2>()


    const [listRelativeCustomer, setListRelativeCustomer] = useState<IRelativeCustomer[]>([])

    const menuRelativeItems: MenuProps["items"] = useMemo(
        () =>
            dataTypeCustomer.map((x) => ({
                key: String(x.value),
                label: x.label,
            })),
        [dataTypeCustomer]);

    const actionColumn: ColDef = {
        headerName: 'Hành động',
        field: 'action',
        colId: 'action',
        width: 200,
        resizable: false,
        suppressMovable: true,
        lockPosition: 'left',
        cellRenderer: (params: any) => {
            const { id, cus_type_name } = params.data
            return (
                <div className='d-flex gap-4 justify-start align-center  h-full'>

                    <EyeOutlined
                        className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
                        onClick={() => navigator(
                            `/customer/list/edit`,
                            {
                                state: {
                                    firstPage: "/customer/list",
                                    id: id,
                                    restorePagination: pagination,
                                    restoreDataFilterList: dataFilterList
                                }
                            }
                        )}
                    />
                    <EditOutlined
                        className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
                        onClick={() => gInfoRelative(id, cus_type_name === 'Đơn vị, tổ chức')}

                    />
                    <div className="custom-page-css h-30px w-30px text-sm border-D9D9D9 shrink-0 flex items-center justify-center bg-white rounded-2 cursor-pointer">
                        <img
                            src={link_slash_solid2} alt=""
                            onClick={() => openModalDelete(Number(id))}
                        />
                    </div>
                </div>

            )
        },
    }

    const gListFieldsActive = async () => {
        const result = await getListFieldsByCustomer(FIELDTYPE.ContactPerson, 1)
        if (result?.status) {
            const flattenedFields = result.data.flatMap(choice =>
                choice.fields.map(field => ({
                    ...field,
                    parentId: choice.id,
                }))
            );
            setDataFieldActive(flattenedFields)
            gListFieldsNotActive()
        }
    }

    const gListFieldsNotActive = async () => {
        const result = await getListFieldsByCustomer(FIELDTYPE.ContactPerson, 0)
        if (result?.status) {
            setDataFieldNoActive(result.data)
        }
    }



    const tableData: any[] = useMemo(() => {
        return listRelativeCustomer.map((item) => {
            const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {

                acc[field.fieldCode] = field.view ? (field.value ? field.value : NO_DATA) : NO_VIEW
                return acc
            }, {})

            Object.entries(requiredFieldCodes).forEach(([fieldCode, defaultValue]) => {
                if (!(fieldCode in fieldValues)) {
                    fieldValues[fieldCode] = defaultValue
                }
            })

            return {
                ...item,
                key: item.id.toString(),
                ...fieldValues,
            }
        })
    }, [listRelativeCustomer])

    const memoizedColumnDefs = useMemo(() => {
        if (ColumnsMapShow.length)
            return generateColumnsFromCodesAgGridReact(
                ColumnsMapShow, dataFieldActive, dataFilterList,
                actionColumn,
                {
                    setDataFilterList
                }
            );
    }, [ColumnsMapShow, dataFieldActive, dataFilterList, tableData]);

    const today = new Date();
    const isBirthday =
        infoCustomer?.birthday &&
        new Date(infoCustomer?.birthday).getDate() === today.getDate() &&
        new Date(infoCustomer?.birthday).getMonth() === today.getMonth();

    const glistRelativeCustomer = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
        setLoadingTable(true)
        if (!infoCustomer?.id) return
        const { search } = dataFilterList
        const result = await getlistRelativeCustomer(
            infoCustomer?.id, 0,
            pageSize, pageCurent, search, [unitTemp]
        )
        if (result?.status) {
            setListRelativeCustomer(result.data)
            setPagination({ current: pageCurent, total: result.total, pageSize })
        } else {
            pushToast(result.message, "warning")
        }
        setLoadingTable(false)
    }, 1000)


    const gInfoRelative = async (id: number, isBusiness: boolean = false) => {

        if (!infoCustomer?.id) return
        const result = await getInfoRelativeCustomer(id, infoCustomer?.id)
        if (result?.status) {
            setInfoRelative(result.data)
            if (!isBusiness)
                setIsModalRelativesUpdate(true)
            else
                setIsModalBusinessUpdate(true)
        } else {
            pushToast(result?.message, "error")
        }
    }

    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
        glistRelativeCustomer(pageNumber, pageSize)
    }

    // const onSaveDataFields = (iSsuccess?: boolean, message?: string, dataFieldsActive?: FlattenedField[], dataFieldsNoActive?: ListField[]) => {
    //     if (iSsuccess) {
    //         setSettingShow(false)
    //         pushToast(message, "success")
    //         setDataFieldActive(dataFieldsActive ?? [])
    //         setDataFieldNoActive(dataFieldsNoActive ?? [])
    //         glistRelativeCustomer(pagination.current, pagination.pageSize)

    //     } else {
    //         pushToast(message, "warning")
    //     }
    // }

    const onSaveDataFields = useThrottle(async (dataFilterActive: FlattenedField[], dataFilterNoActive: ListField[]) => {
        let result: any;
        const activeFields: FieldsUpdate[] = dataFilterActive.map(item => ({
            fieldId: item.id,
            isActive: 1, // hoặc true tùy bạn muốn mặc định là gì
        }));
        const allFieldsDefaultInactive: FieldsUpdate[] = dataFilterNoActive.flatMap(group =>
            group.fields.map(field => ({
                fieldId: field.id,
                isActive: 0,
            }))
        );
        const listActiveFields = activeFields.concat(allFieldsDefaultInactive)

        result = await updateFieldUser(id, FIELDTYPE.ContactPerson, undefined, listActiveFields)

        if (result?.status) {
            pushToast(result?.message, "success")
            setSettingShow(false)

            if (dataFilterActive && dataFilterNoActive) {

                setDataFieldActive(dataFilterActive ?? [])
                setDataFieldNoActive(dataFilterNoActive ?? [])
            }

        } else {
            pushToast(result?.message, "warning")
        }
    }, 2000)

    const onCloseDataFields = () => {
        setSettingShow(false)
    }

    //NT
    const onSubmitFormModalAddRelative = (iSsuccess: boolean, message?: string) => {
        if (iSsuccess) {
            glistRelativeCustomer(pagination.current, pagination.pageSize)
            setIsAddRelativeModal(false)
            pushToast(message, "success")
        } else {
            pushToast(message, "error")
        }
    }

    //DN
    const onSubmitFormModalAddBusiness = (iSsuccess: boolean, message?: string) => {
        if (iSsuccess) {
            glistRelativeCustomer(pagination.current, pagination.pageSize)
            setIsModalBusinessAdd(false)
            pushToast(message, "success")
        } else {
            pushToast(message, "error")
        }
    }

    const onSubmitFormModalUpdateRelativeAndBusiness = (iSsuccess: boolean, message?: string) => {
        if (iSsuccess) {
            glistRelativeCustomer(pagination.current, pagination.pageSize)
            setIsModalRelativesUpdate(false)
            setIsModalBusinessUpdate(false)
            pushToast(message, "success")
        } else {
            pushToast(message, "error")
        }
    }

    const openModalDelete = (id: number) => {
        setIDChoose(id)
        setIsModalRelativesDelete(true)
    }

    const onConfirmDelete = async () => {
        if (!infoCustomer?.id) return
        const result = await deleteRelativeCustomerChild(Number(infoCustomer.id), Number(idChoose))
        if (result?.status) {
            pushToast(result?.message, "success")
            glistRelativeCustomer(pagination.current, pagination.pageSize)
        } else {
            pushToast(result?.message, "warning")
        }
        setIsModalRelativesDelete(false)
    }

    const closeModalDelete = () => {
        setIDChoose(undefined)
        setIsModalRelativesDelete(false)
    }

    useEffect(() => {
        const codes = dataFieldActive.map(f => f.fieldCode)
        setColumnsMapShow(codes)
    }, [dataFieldActive])

    useEffect(() => {
        if (infoCustomer?.id) {
            glistRelativeCustomer()
        }

    }, [dataFilterList, infoCustomer])

    return (
        <Fragment>
            {
                isSettingShow ?
                    <TabsFeildsCustomer
                        isSettingShow={isSettingShow}
                        dataFilterActive={dataFieldActive}
                        dataFilterNoActive={dataFieldNoActive}

                        onSaveDataFields={onSaveDataFields}
                        onClose={onCloseDataFields}
                    /> :
                    null
            }

            <AddRelativeModal
                infoCustomer={infoCustomer}
                show={isAddRelativeModal}
                modalClose={() => setIsAddRelativeModal(false)}
                onSuccess={() => setIsAddRelativeModal(false)}
                onSubmitFormModal={onSubmitFormModalAddRelative}
            />

            <UpdateRelative
                show={isModalRelativesUpdate}
                infoCustomer={infoCustomer}
                infoRelative={infoRelative}
                modalClose={() => setIsModalRelativesUpdate(false)}
                onSubmitFormModal={onSubmitFormModalUpdateRelativeAndBusiness}
            />

            <AddBusiness
                show={isModalBusinessAdd}
                infoCustomer={infoCustomer}

                modalClose={() => setIsModalBusinessAdd(false)}
                onSubmitFormModal={onSubmitFormModalAddBusiness}
            />

            <UpdateBusiness
                show={isModalBusinessUpdate}
                infoCustomer={infoCustomer}
                infoBusiness={infoRelative}
                modalClose={() => setIsModalBusinessUpdate(false)}
                onSubmitFormModal={onSubmitFormModalUpdateRelativeAndBusiness}
            />


            <ModalDeleteManager
                isOpen={isModalRelativesDelete}
                title="Bạn có chắc chắn xóa người liên hệ này"
                titleDelete="Xóa người liên hệ"
                content="người liên hệ và dữ liệu liên quan sẽ bị xóa vĩnh viễn
      không thể khôi phục"
                onConfirm={onConfirmDelete}
                closeModal={closeModalDelete}
            />


            <div className='custom-page-css w-full py-3 flex flex-column gap-3'>
                <div
                    className={`custom-page-css w-full p-5 rounded border relative ${!false && 'd-none'}`}
                >
                    <div className=" absolute  bottom-0 right-0  flex items-end">
                        <img src={logo_card} alt="" style={{ width: 100, height: 60, objectFit: 'contain' }} />
                    </div>
                    <span className='custom-page-css text-xl font-light text-475467'>Hôm nay là sinh nhật của khách hàng
                        <span className='custom-page-css font-medium px-1 text-344054'>
                            {/* {`${infoCustomer?.userName[0]?.username} (${formatDateToDMY(infoCustomer?.birthday ??infoCustomer?.foundingDate)})`}. */}
                        </span>
                        Hãy gửi lời chúc tới khách hàng.</span>


                </div>

                {/* Sinh nhật */}
                <div className={infoCustomer?.birthdayMessage ? "custom-page-css flex items-center gap-4 w-full px-5 py-2 rounded border relative " : "d-none"}>
                    <div className="custom-page-css flex items-center justify-center p-2 bg-E6F7FF rounded  ">
                        <GiftOutlined className='custom-page-css  text-base text-1890FF ' />
                    </div>

                    <div className=" absolute  bottom-0 right-0  flex items-end">
                        <img src={logo_card} alt="" style={{ width: 100, height: 50, objectFit: 'contain' }} />
                    </div>
                    <span className='custom-page-css text-xl font-light text-475467'>
                        {infoCustomer?.birthdayMessage}
                        {/* <span className='custom-page-css font-medium px-1 text-344054'>({infoCustomer?.birthday}).</span> */}
                    </span>


                </div>
                {/* Thông báo nhắc bảo dưỡng xe */}
                <div className={infoCustomer?.serviceRemindMessage ? "custom-page-css flex items-center gap-4 w-full px-5 py-2 rounded border relative " : "d-none"}>
                    <div className="custom-page-css flex items-center justify-center p-2 bg-E6F7FF rounded  ">
                        <ToolOutlined className='custom-page-css  text-base text-1890FF ' />
                    </div>


                    <span className='custom-page-css text-xl font-light text-475467'>
                        {infoCustomer?.serviceRemindMessage}


                    </span>
                    <div
                        style={{
                            zIndex: 9999,
                            position: 'relative',
                            marginLeft: 'auto'
                        }}
                    >
                        < Tooltip

                            placement="right"
                            color="white"
                            title={
                                <div
                                    style={{
                                        maxHeight: 400,       // chiều cao cố định
                                        overflowY: "auto",    // bật scroll dọc
                                    }}
                                    className="space-y-2"
                                >
                                    <div className="custom-page-css flex items-center gap-2 h-fit" >
                                        <span className="color-bage-custom fs-14">
                                            {getFieldValueObjectTooltip(infoCustomer?.serviceRemindList)}
                                        </span>
                                    </div>
                                </div>
                            }
                        >
                            <div className="action-icons action-icons-bage ml-auto px-2 fs-14 cursor-pointer custom-page-css h-fit">
                                <div className="font-light color-bage" >{infoCustomer?.serviceRemindList?.length ?? 0}</div>
                                <img src={info_cicrle} alt="Avatar" />
                            </div>
                        </Tooltip>
                    </div>
                    <div className=" absolute  bottom-0 right-0  flex items-end">
                        <img src={logo_card} alt="" style={{ width: 100, height: 50, objectFit: 'contain' }} />
                    </div>
                </div>

                <div className="custom-page-css w-full flex gap-3">
                    <div className="custom-page-css  flex flex-1 flex-column rounded border">
                        <div className="custom-page-css w-full flex items-center justify-center gap-4 p-3 border-b">
                            <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full ">
                                <img src={Dashboard} alt="" style={{ height: 16, width: 16, objectFit: 'contain' }} />
                            </div>
                            <span className='custom-page-css text-xl font-light  text-000000'>Tổng xe sở hữu
                                <span className='custom-page-css font-medium px-1  text-000000'>
                                    {infoCustomer?.permissions?.totalOwnerVehicles ? formatNumber(infoCustomer?.totalOwnerVehicles ?? 0) : NO_VIEW}
                                </span>
                            </span>
                        </div>
                        <div className="custom-page-css flex py-2">
                            <div className="custom-page-css py-2 flex flex-2 flex-column items-center justify-center gap-1 border-r">
                                <span className='custom-page-css text-2xl font-light font-medium px-1  text-000000'>
                                    {infoCustomer?.permissions?.totalVehiclePassenger ? formatNumber(infoCustomer?.totalVehiclePassenger ?? 0) : NO_VIEW}
                                </span>
                                <span className='custom-page-css text-xl font-light  text-000000'>Xe du lịch</span>
                            </div>
                            <div className="custom-page-css py-2 flex flex-2 flex-column items-center justify-center gap-1 border-r">
                                <span className='custom-page-css text-2xl font-light font-medium px-1  text-000000'>
                                    {/* {formatNumber(infoCustomer?.totalVehicleBus ?? 0)} */}
                                    {infoCustomer?.permissions?.totalVehicleBus ? formatNumber(infoCustomer?.totalVehicleBus ?? 0) : NO_VIEW}
                                </span>
                                <span className='custom-page-css text-xl font-light  text-000000'>Xe tải bus</span>
                            </div>
                            <div className="custom-page-css py-2 flex flex-3 flex-column items-center justify-center gap-1 ">
                                <span className='custom-page-css text-2xl text-center font-light font-medium px-1  text-000000'>
                                    {/* {infoCustomer?.invoiceSaleDocDate ?? NO_DATA} */}
                                    {infoCustomer?.permissions?.invoiceSaleDocDate ? (infoCustomer?.invoiceSaleDocDate ?? NO_DATA) : NO_VIEW}
                                </span>
                                <span className='custom-page-css text-xl font-light text-center text-000000'>Ngày mua xe gần nhất</span>
                            </div>
                        </div>
                    </div>
                    <div className="custom-page-css  flex flex-1 flex-column rounded border">
                        <div className="custom-page-css w-full flex items-center justify-around gap-4 p-3 border-b">
                            <div className="custom-page-css flex items-center justify-center gap-3">
                                <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full ">
                                    <img src={Dashboard} alt="" style={{ height: 16, width: 16, objectFit: 'contain' }} />
                                </div>
                                <span className='custom-page-css text-xl font-light  text-000000'>Tổng chi tiêu
                                    <span className='custom-page-css font-medium px-1  text-000000'>
                                        {infoCustomer?.permissions?.totalAmount ? formatNumber(infoCustomer?.totalAmount ?? 0) : NO_VIEW}
                                    </span>
                                </span>
                            </div>

                        </div>
                        <div className="custom-page-css flex py-2">
                            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
                                <span className='custom-page-css text-2xl font-light font-medium px-1  text-000000'>
                                    {infoCustomer?.permissions?.totalPurchaseAmount ? formatNumber(infoCustomer?.totalPurchaseAmount ?? 0) : NO_VIEW}
                                </span>
                                <span className='custom-page-css text-xl font-light  text-000000'>Hóa đơn mua xe </span>
                            </div>
                            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 ">
                                <span className='custom-page-css text-2xl font-light font-medium px-1  text-000000'>
                                    {infoCustomer?.permissions?.totalServiceAmount ? formatNumber(infoCustomer?.totalServiceAmount ?? 0) : NO_VIEW}
                                </span>
                                <span className='custom-page-css text-xl font-light  text-000000'>Hóa đơn dịch vụ </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3">
                    <span className='custom-page-css font-regular  text-xl text-1890FF border-b-1890FF'>
                        Người liên hệ ({pagination.total})
                    </span>
                    <div className="custom-page-css  flex items-center justify-end gap-3 ">
                        <div className="custom-page-css h-8 w-8 flex items-center justify-center rounded border cursor-pointer"
                            onClick={() => setSettingShow(true)}
                        >
                            <SettingOutlined />
                        </div>
                        <div className="custom-page-css h-8 w-8 flex items-center justify-center rounded border cursor-pointer">
                            {/* <MoreOutlined /> */}
                            {/* <Dropdown menu={{ items }} trigger={['click']}>
                                <PlusOutlined />
                            </Dropdown> */}
                            <Dropdown
                                menu={{
                                    items: menuRelativeItems,
                                    onClick: ({ key }) => {
                                        if (Number(key) === CustomerType.Individual)
                                            //ca nhan
                                            setIsAddRelativeModal(true)
                                        else
                                            setIsModalBusinessAdd(true)
                                    },
                                }}
                                trigger={["click"]}
                                placement="bottomLeft"

                            >
                                <PlusOutlined />
                            </Dropdown>
                        </div>

                    </div>
                </div>
                <div className="custom-page-css w-full flex gap-3">
                    <div className="custom-page-css w-1-3 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3  py-1 h-8 justify-between overflow-hidden">
                        <Input
                            placeholder="Tìm kiếm theo người liên hệ"
                            className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
                            value={dataFilterList.search}
                            onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
                        />
                        <div className=" border-l-F2F4F7 h-full d-flex align-center">
                            <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                        </div>
                    </div>
                </div>

                <div className={`order-history-card__body`}>
                    <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%' }}>
                        <AgGridReact
                            domLayout="autoHeight"
                            className="my-auto-height-grid"
                            getRowStyle={(params: any) => ({
                                backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                            })}

                            rowData={tableData}
                            columnDefs={memoizedColumnDefs}
                            rowHeight={55}
                            overlayNoRowsTemplate={NodataTable}

                            loading={loadingTable}
                            loadingOverlayComponent={CustomLoadingOverlayTable}
                            // Thêm các props sau để cải thiện scroll
                            rowBuffer={20}
                            maxBlocksInCache={10}
                            infiniteInitialRowCount={1000}

                            // Performance optimizations
                            suppressColumnVirtualisation={true} // Giữ tất cả columns trong DOM
                            suppressRowVirtualisation={false} // Giữ row virtualization
                            enableCellTextSelection={true}
                            ensureDomOrder={true}
                            debounceVerticalScrollbar={true}
                            suppressScrollOnNewData={true}
                            // Thêm các props này để luôn hiển thị scrollbars
                            alwaysShowHorizontalScroll={true}
                            // Xoá khi kéo lên
                            suppressDragLeaveHidesColumns={true}

                        />

                    </div>
                    <ConfigProvider locale={viVN}>
                        <div className="pagination-block">
                            <Pagination
                                showSizeChanger
                                pageSize={pagination.pageSize}
                                total={pagination.total}
                                itemRender={(page, type, originalElement) => {
                                    // Chỉ custom khi là nút số trang
                                    if (type === 'page') {
                                        return <span>{formatNumber(page)}</span>;
                                    }
                                    // prev / next / jump-prev / jump-next giữ nguyên
                                    return originalElement;
                                }}
                                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                                className='rs-pagination'
                                onChange={onPaginationChange}

                            />
                        </div>
                    </ConfigProvider>
                </div>

            </div>
        </Fragment>
    )
}
export default memo(Overview)
